module.exports = __webpack_public_path__ + "img/itemCrafting.fbdc55ec.png";